import React, { useState } from 'react'
import axios from 'axios'
import {
  Container,
  Card,
  CardActions,
  CardContent,
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  Snackbar,
} from '@material-ui/core'
import StdButton from '@material-ui/core/Button'
import { Field, Form, Formik } from 'formik'
import { TextField } from 'formik-material-ui'
import { makeStyles } from '@material-ui/core/styles'
import MuiAlert from '@material-ui/lab/Alert'
import { useLocation } from '@reach/router'
import { parse } from 'query-string'

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: '#00aaff', // Custom color for the background
  },
  container: {
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  rightButton: {
    marginLeft: 'auto',
  },
  amountPaid: {
    marginTop: theme.spacing(2),
  },
  snackbarAlert: {
    backgroundColor: '#0000ff', // Set the Snackbar background to blue
    color: '#ffffff',
    display: 'flex',
    alignItems: 'center',
    padding: '16px',
  },
  snackbarMessage: {
    flexGrow: 1,
    textAlign: 'center',
    fontSize: '1.5rem',
    fontWeight: 'bold',
  },
}))

function Alert(props) {
  const classes = useStyles()
  return <MuiAlert elevation={6} variant="filled" {...props} className={classes.snackbarAlert} />
}

export default function Calculator() {
  const classes = useStyles()
  const location = useLocation()

  const queryParams = parse(location.search)
  const tippeeId = queryParams.id
  const locationId = queryParams.location

  const [amountPaid, setAmountPaid] = useState(0)
  const [open, setOpen] = useState(false)
  const [values, setValues] = useState({
    weightInTon: '',
    ratePerTon: '',
    materialType: '',
  })
  const [snackbarOpen, setSnackbarOpen] = useState(false)
  const [snackbarMessage, setSnackbarMessage] = useState('')

  const handleConfirm = async resetForm => {
    setOpen(false)
    try {
      const params = new URLSearchParams({
        id: tippeeId,
        location: locationId,
      })

      await axios.post(
        `${
          process.env.REACT_APP_T4C_API_ADDR
        }/recycle/calculate?${params.toString()}`,
        values,
      )

      setSnackbarMessage(
        `Amount to be paid: ${amountPaid}. Please pay your reclaimer via SnapScan or Zapper.`,
      )
      setSnackbarOpen(true)

      resetForm()
      setAmountPaid(0)
    } catch (error) {
      console.error('There was an error calculating the amount:', error)
    }
  }

  const handleCalculate = (values, resetForm) => {
    const { weightInTon, ratePerTon } = values
    const result = weightInTon * ratePerTon
    setAmountPaid(result)
    setValues(values)
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  const handleCloseSnackbar = () => {
    setSnackbarOpen(false)
  }

  return (
    <div className={classes.root}>
      <Container maxWidth="sm" className={classes.container}>
        <Card elevation={0}>
          <Formik
            initialValues={{
              weightInTon: '',
              ratePerTon: '',
              materialType: '',
            }}
            onSubmit={(values, { setSubmitting, resetForm }) => {
              handleCalculate(values, resetForm)
              setSubmitting(false)
            }}
          >
            {({ isSubmitting, resetForm }) => (
              <>
                <Form>
                  <CardContent>
                    <Typography color="textSecondary" gutterBottom>
                      Calculate Amount To Be Paid
                    </Typography>
                    <Field
                      component={TextField}
                      name="materialType"
                      type="text"
                      label="Material Type"
                      color="secondary"
                      fullWidth
                    />
                    <Field
                      component={TextField}
                      name="weightInTon"
                      type="number"
                      label="Weight In Ton"
                      color="secondary"
                      fullWidth
                    />
                    <Field
                      component={TextField}
                      name="ratePerTon"
                      type="number"
                      label="Rate Per Ton"
                      color="secondary"
                      fullWidth
                    />
                    <Typography
                      className={classes.amountPaid}
                      color="textPrimary"
                      gutterBottom
                    >
                      Amount To Be Paid: {amountPaid}
                    </Typography>
                  </CardContent>
                  <CardActions disableSpacing>
                    <StdButton
                      variant="contained"
                      color="primary"
                      disabled={isSubmitting}
                      type="submit"
                    >
                      Calculate
                    </StdButton>
                  </CardActions>
                </Form>

                <Dialog
                  open={open}
                  onClose={handleClose}
                  aria-labelledby="confirm-dialog-title"
                  aria-describedby="confirm-dialog-description"
                >
                  <DialogTitle id="confirm-dialog-title">
                    Confirm Amount
                  </DialogTitle>
                  <DialogContent>
                    <DialogContentText id="confirm-dialog-description">
                      Are you sure this is the correct amount: {amountPaid}?
                    </DialogContentText>
                  </DialogContent>
                  <DialogActions>
                    <Button onClick={handleClose} color="primary">
                      No
                    </Button>
                    <Button
                      onClick={() => handleConfirm(resetForm)}
                      color="primary"
                      autoFocus
                    >
                      Yes
                    </Button>
                  </DialogActions>
                </Dialog>
              </>
            )}
          </Formik>
        </Card>
      </Container>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity="info"
          className={classes.snackbarAlert}
        >
          <Typography className={classes.snackbarText}>
            {snackbarMessage}
          </Typography>
        </Alert>
      </Snackbar>
    </div>
  )
}
